import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import StarfieldCanvas from '../StarfieldCanvas/StarfieldCanvas';
import { ScrollProvider } from '../../context/ScrollContext';
import { MessageModalProvider } from '../../contexts/MessageModalContext';
import MessageModal from '../MessageModal/MessageModal';
import './Layout.css';

export default function Layout() {
  return (
    <ScrollProvider>
      <MessageModalProvider>
        <div className="site-shell">
          <StarfieldCanvas />
          <div className="site-curtain" aria-hidden="true" />
          <Navbar />
          <main>
            <Outlet />
          </main>
          <Footer />
        </div>
        <MessageModal />
      </MessageModalProvider>
    </ScrollProvider>
  );
}
